import { SignInPage } from '@backstage/core-components';
import { configApiRef, useApi } from '@backstage/core-plugin-api';
import { microsoftAuthApiRef } from '@backstage/frontend-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import { createElement } from 'react';

export const SignInPageExtension = SignInPageBlueprint.make({
  params: {
    loader: async () => props => {
      const configApi = useApi(configApiRef);
      const providers = [
        ...(configApi.getString('auth.environment') === 'development'
          ? ['guest' as const]
          : []),
        {
          apiRef: microsoftAuthApiRef,
          id: 'microsoft-auth-provider',
          message: 'Sign in using Azure',
          title: 'Authentication',
        },
      ];

      return createElement(SignInPage, {
        ...props,
        auto: true,
        providers,
      });
    },
  },
});
